// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__qe2n8","title":"BackImages_title__14Wg2","images":"BackImages_images__bE29_"};